import { createFileRoute } from "@tanstack/react-router";
import AdminModerationDetailPage from "@/admin/pages/moderation-detail";

export const Route = createFileRoute("/admin/moderation/$reportId")({
  component: AdminModerationDetailPage,
});
